
import { Helper } from "../../../dev/utils/Helper";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { TextStyleOptions } from "../../../dev/setting/text/IText";
import { TranslationTexts } from "../../config/translate/TranslationTexts";
import { LayoutDimData, ResizeHelper, IDimOrientation } from "../../../dev/utils/ResizeHelper";
import {  gsap } from "gsap";

export class WaysStateLevel extends StateHandler{

    public static LEVEL_1:number = 0;
    public static LEVEL_2:number = 1;
    public static LEVEL_3:number = 2;

    protected static ValueLvls:number[] = [800,3200,7600];

    public get lastLvl():number{
        return WaysStateLevel.ValueLvls[this.value-1] ? WaysStateLevel.ValueLvls[this.value-1] : 0;
    }

    public get nextLvl():number{
        return WaysStateLevel.ValueLvls[this.value+1] ? WaysStateLevel.ValueLvls[this.value+1] : 100000000000000;
    }

    public get valueLvl():number{
        return WaysStateLevel.ValueLvls[this.value]
    }
    
    public set(value:number):boolean{
        if(value > WaysStateLevel.LEVEL_3 || value < WaysStateLevel.LEVEL_1) return false;
        super.set(value);
        return true;
    }
}

export class WaysCounter extends PIXI.Container {
    
    private _value:number = 243;
    private _textCounter:PIXI.Text;
    private _textPost:PIXI.Text;

    private _timeLine:gsap.core.Timeline;
    private static _instance:WaysCounter;
    //Header
    private _countsUp:boolean = true;

    private _wayState:WaysStateLevel = new WaysStateLevel(WaysStateLevel.LEVEL_1);

    private CounterDim:IDimOrientation = {
        landscape :{
            scale:      new PIXI.Point( 1, 1),
            position:   new PIXI.Point( -93, 280),
        },
        portrait :{
            scale:      new PIXI.Point( 1, 1),
            position:   new PIXI.Point( 100, 0),
        }
    };

    private get value(){
        return this._value;
    }

    private set value(val:number){
        this._value = val;
        this.updateValue();
    }

    private readonly _styleWays_main: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 1.2,
        fontSize:32,
        dropShadowColor: "#D6D6D6",
        fill: "#333",
        fontFamily: "Helvetica",
        fontStyle: "oblique",
        fontWeight: "bolder"
    };
    
    public static get instance():WaysCounter{ return WaysCounter._instance; };


    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.CounterDim); };

    constructor() {
        super();

        WaysCounter._instance = this;
        this.name = "WaysCounter";
        this.initAnimations();
    }

    protected initAnimations():void{
        
        this._textCounter = this.createTextObject();

        this._textPost = this.addChild(new PIXI.Text(TranslationTexts.WAYS));
        this._textPost.style = this._styleWays_main;
        
        this._textPost.anchor.set(0.5,0.5);
        this._textPost.scale.set(0.72,0.72);
        this.onResize();
    }

    protected createTextObject():PIXI.Text{
        const textObj = new PIXI.Text(this.value.toString());
        textObj.style = this._styleWays_main;
        textObj.anchor.set(0.5,0.5);
        this.addChild(textObj);
        return textObj;
    }

    public hardSetValue(value:number):void{
        this.value = value;
        this.updateValue();
    }

    public setValue(from:number | undefined, to:number, duration:number = 0.25):gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline());
        if (!this._textCounter.visible) return this._timeLine;
        if (this.value == to) return this._timeLine;
        let fromValue = from != undefined ? from : this.value;

        this._countsUp = to > fromValue;

        this._timeLine = new gsap.core.Timeline({ onComplete: () => this.hardSetValue(to) });
        this._timeLine.fromTo(this, { value: fromValue }, { value: to, duration: duration });

        return this._timeLine;
    }

    protected updateValue():void{
        
        this._textCounter.text = this.value.toFixed(0);

        if(!this._textCounter.visible) return;

        if(this._countsUp){
            if(this.value > this._wayState.valueLvl && this._wayState.set(this._wayState.value+1)){
                gsap.to(this._textCounter.scale,0.15,{x:1.2,y:1.2}).eventCallback("onComplete",() => {gsap.to(this._textCounter.scale,0.15,{x:1,y:1})})
            }
        }else{
            if(this.value < this._wayState.lastLvl && this._wayState.set(this._wayState.value-1)){
                gsap.to(this._textCounter.scale,0.1,{x:0.95,y:0.95}).eventCallback("onComplete",() => {gsap.to(this._textCounter.scale,0.1,{x:1,y:1})})
            }
        }

        this._textCounter.updateTransform();
    }

    public onResize():void{

        this.visible = false;//!ResizeHelper.isIPadd;
        this.position = this.dim.position;
        this.scale = this.dim.scale;

        this._textPost.position = this._textCounter.position;
        this._textPost.position.y += this._textPost.height * 1.05;

        // this.visible = false;

    }
}